/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Route, Navigate, Outlet } from 'react-router-dom';
import Authenticated from '../../shared/Authenticated';
import MasterPermissions from '../../api/MasterPermissions';

const ProtectedRouteLatest = ({ permissionName, ...rest }) => {
  const isAuth = Authenticated.isAuthenticated();
  console.log('Protected Route -> isAuthenticated: ', isAuth);
  const hasPermission =
    permissionName != undefined
      ? MasterPermissions.CheckPermission(permissionName)
      : true;

  return isAuth ? (
    hasPermission ? (
      <Outlet />
    ) : (
      <Navigate to="/admin/admin-dashboard" />
    )
  ) : (
    <Navigate to="/admin" />
  );
};
export default ProtectedRouteLatest;
